import type { HostListing as HostListingType } from '@wix/ambassador-os-backoffice-v1-host-listing/types';

export class HostListing {
  constructor(private readonly hostListing: HostListingType | undefined) {}

  get id(): string {
    return this.hostListing?.id ?? '';
  }

  get revision(): string {
    return this.hostListing?.revision ?? '';
  }

  get enabledPackageIds(): Set<string> {
    return new Set(
      (this.hostListing?.targets ?? [])
        .map((target) => target.package?.packageId)
        .filter((id) => Boolean(id)) as string[],
    );
  }

  get installedAppIds(): Set<string> {
    return new Set(
      (this.hostListing?.targets ?? [])
        .map((target) => target.app?.appId)
        .filter((id) => Boolean(id)) as string[],
    );
  }

  isPackageEnabled(packageId: string): boolean {
    return this.enabledPackageIds.has(packageId);
  }
}
